import React from 'react';
import { useBlobStorage } from 'hooks/useBlobStorage';
import FileUploadStep from './Modals/FileUploadStep';
import { useFileUploads } from 'hooks/useFileUploads';
import { useWorkspaceContext } from 'hooks/common';
import { FileRejection } from 'react-dropzone';

type MemoryFileUploadProps = { memoryID: string | undefined };

function MemoryFileUpload({ memoryID }: MemoryFileUploadProps) {
  const { getWorkspace } = useWorkspaceContext();
  const workSpace = getWorkspace();
  const { mutateAsync: uploadFiles } = useFileUploads();
  const { handleFileUpload, handleDelete, uploads, setUploads } =
    useBlobStorage(workSpace?.attributes.containerName || 'temp');
  let uploadFilesURLs: (string | undefined)[];

  const handleSubmit = async () => {
    if (!memoryID) {
      return;
    }
    const response = await uploadFiles({
      memoryID: memoryID,
      files: uploadFilesURLs.map((fileUrl) => ({ url: fileUrl })),
    });
    if (response) {
      setUploads([]);
    }
  };

  const handleSuccessfulUpload = async (
    acceptedFiles: File[],
    fileRejections: FileRejection[]
  ) => {
    const result = await handleFileUpload(acceptedFiles, fileRejections);
    const URLs = result?.map((upload) => upload.url);
    if (URLs?.length) {
      uploadFilesURLs = URLs;
      await handleSubmit();
    }
    return URLs;
  };

  return (
    <FileUploadStep
      handleNextClick={() => {}}
      handleFileUpload={handleSuccessfulUpload}
      uploads={uploads}
      handleDelete={handleDelete}
      shouldLabelRender={false}
      shouldNextButtonRender={false}
    />
  );
}

export default MemoryFileUpload;
